if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super()

      this.form = this.querySelector('form')
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.form?.addEventListener('CUSTOM_SUBMIT', this.onSubmitHandler.bind(this))
      this.miniCart = document.getElementById('mini-cart');
      this.bubble = document.getElementById('cart-icon-bubble');
    }

    getSectionsToRender() {
      if(document.body.classList.contains('template-cart')) {
        return [
          {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
        ]
      } else {
        return [
          {
            id: 'mini-cart',
            section: document.getElementById('mini-cart').dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
        ]
      }
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML
    }

    onSubmitHandler(evt) {
      evt.preventDefault()
      document.dispatchEvent(new CustomEvent('cart:loading'))

      const submitButton = this.querySelector('[type="submit"]')
      const statusBlock = document.querySelector('product-totals')

      submitButton.setAttribute('disabled', true)
      submitButton.classList.add('loading')
      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      })


      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      try {

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            this.handleErrorMessage();
            return response;
          })
          .then((state) => {
            if (state == undefined ) {
              return
            }


            const parsedState = state;
            const cartItems = window.__CART__.items
            let alreadyInCart = false
            if (cartItems.length) {
              window.__CART__.items.map((item) => {
                if (item.id === parsedState.id) {
                  item.quantity = parsedState.quantity
                  alreadyInCart = true
                }
              })
            }
            if (!alreadyInCart) {
              window.__CART__.items.push(parsedState)
            }

            document.dispatchEvent(new CustomEvent('cart-updated', {
              bubbles: true
            }))

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id)

              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              )
            })
            document.getElementById('cart-icon-bubble').click()
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            submitButton.classList.remove('loading')
            submitButton.removeAttribute('disabled')
            statusBlock?.updateText(JSON.parse(body)?.quantity)
            fetch(window.Shopify.routes.root + 'cart.js')
              .then(response => response.json())
              .then(data => {
                this.bubble.innerHTML = data.item_count;
                const form_variant_id = formData.get('id')
                const form_max_quantity = formData.get('max_quantity')
                data.items.forEach((item) => {
                  if (item.variant_id == form_variant_id) {
                    if (item.quantity >= form_max_quantity && form_max_quantity != null) {
                      submitButton.setAttribute('disabled', '')
                    }
                  }
                })
              })
              .catch((e) => {
                console.error(e)
              })
              .finally(() => {
                document.dispatchEvent(new CustomEvent('cart:loaded'))
              });
            document.dispatchEvent(new CustomEvent('cart:loaded'))
          })
      } catch (e) {
        document.dispatchEvent(new CustomEvent('cart:loaded'))
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

      if (this.errorMessageWrapper == undefined) {
        return;
      }

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
      document.dispatchEvent(new CustomEvent('cart:loaded'))
    }

  }

  customElements.define('product-form', ProductForm)
}
